import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {StyledCard} from "./PriceCard.styled";
import style from "./PriceCards.module.scss";

import {FaChevronLeft} from "react-icons/fa6";
import LocationPopup from "../locationPopup/LocationPopup";
import {OnLocationConfirm, PriceCardProps} from "../../models";
import PricePopup from "../pricePopup/PricePopup";
import {useLocation} from "react-router-dom";
const PriceCard = ({onConfirm} : PriceCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [chosenItems, setChosenItems] = useState<any>([])
    const location = useLocation();
    const openPriceModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }

    useEffect(() => {
        if (location?.state?.stepTwoForm?.productPricings)
            setChosenItems(location?.state?.stepTwoForm?.productPricings)
    }, [location]);
    return (
    <>        <StyledCard className={'shadow-sm'} onClick={openPriceModal}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex align={"center"} gap={"small"}>
                   <span>قیمت</span>
                </Flex>
                <Flex gap={"small"} align={"center"}>
                    {chosenItems?.length > 0  && <span className={style.icons}>{chosenItems?.length} مورد انتخاب شده </span>}
                   <span> <FaChevronLeft  className={style.icons}/> </span>
                </Flex>

            </Flex>
        </StyledCard>
        <PricePopup open={open} onCansel={onCansel} onConfirm={(form:any) => {
            onConfirm(form)
            setChosenItems(form)
        }}/>
    </>

);
};

export default PriceCard;
